const DynamicPagesActionTypes = {};

DynamicPagesActionTypes.FETCH_ALL_DYNAMIC_PAGES = 'FETCH_ALL_DYNAMIC_PAGES';
DynamicPagesActionTypes.FETCH_DYNAMIC_PAGES = 'FETCH_DYNAMIC_PAGES';
DynamicPagesActionTypes.ADD_DYNAMIC_PAGES = 'ADD_DYNAMIC_PAGES';
DynamicPagesActionTypes.EDIT_DYNAMIC_PAGES = 'EDIT_DYNAMIC_PAGES';
DynamicPagesActionTypes.DELETE_DYNAMIC_PAGES = 'DELETE_DYNAMIC_PAGES';

export default DynamicPagesActionTypes;
